import { optionValues } from '../../../grouping/components/selectorOptions';

export const ALL_VALUE = '';

/** Values a multiple selector ends up with: picking "All" while values are picked clears them. */
export function nextPickedValues(selected: unknown, activeValues: string[]): string[] {
  const values = optionValues(selected);
  const pickedAll = activeValues.length > 0 && values.includes(ALL_VALUE);
  return pickedAll ? [] : values.filter(value => value !== ALL_VALUE);
}
